import mutations from './simpleImport.mutations'
import actions from './simpleImport.actions'
import getters from './simpleImport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
